import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=4afd20e4&"
import script from "./Tooltip.vue?vue&type=script&lang=js&"
export * from "./Tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports